import React, { Component }  from 'react';
import { GETPRODUCTIONORDERSTEPS, SENDTOQDOC, GETQDOCPATH } from '../../constants/Config';
import { useTranslation, Trans } from 'react-i18next';
import OrderStepInfo from '../OrderStepInfo';
import { MenuItem, Grid, Menu, Fab, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
const { t } = useTranslation();

class OrderInfoPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          isLoaded: false,
          ordersteps: [],
          anchorEl: null,
          dialogVisible: false,
          DialogContent: "",
          DialogTitle: ""
        };
        
        this.getProductionOrderSteps = this.getProductionOrderSteps.bind(this);
      }
      _isMounted = false;

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    showQualityDocument() {
        fetch(GETQDOCPATH + this.props.match.params.productionOrderID, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }

                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }

            this.setState({ DialogContent: res.results[0] });
            this.setState({ dialogVisible: true });

            this.setState({ anchorEl: null });
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    handleCloseDialog = () => {
        this.setState({ dialogVisible: false });
    }

    sendToQdoc() {
        fetch(SENDTOQDOC + this.props.match.params.productionOrderID, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }

                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }
            this.setState({ anchorEl: null });
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    componentDidMount() {
        let number = decodeURIComponent(this.props.match.params.ordernumber);
        this.props.setHeader(number);

        this._isMounted = true;

        this.getProductionOrderSteps();
    }

    getProductionOrderSteps = () => {
        fetch(GETPRODUCTIONORDERSTEPS + this.props.match.params.productionOrderID, {method: 'GET'})
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {
                    const error = (data && data.message) || response.statusText;
                    toast.error(error, {
                        position: toast.POSITION.TOP_CENTER
                      });
                    return Promise.reject(error);
                }

                return data;
            });
        })
        .then((res) => {
            if(res.succeeded === false) {
                for (let index = 0; index < res.messages.length; index++) {
                    toast.error(res.messages[index], {
                        position: toast.POSITION.TOP_CENTER
                      });
                }
                return Promise.reject();
            }

            if (this._isMounted) {
                this.setState({
                isLoaded: true,
                ordersteps: res.results
                });
            }

            if(res.results.length === 0) {
                toast.error(<Trans>{t('NoSteps')}</Trans>, {
                    position: toast.POSITION.TOP_CENTER
                  });
            }

            return true;
        })
        .catch(function(error) {
            toast.error(error, {
                position: toast.POSITION.TOP_CENTER
              });
        });
    }

    render() {
        const { anchorEl } = this.state;  
        let ordersteps = this.state.ordersteps.map((p) => (<OrderStepInfo key={p.id} {...p} getProductionOrderSteps={this.getProductionOrderSteps} ></OrderStepInfo>));
        return (
            <div>
                <Dialog open={this.state.dialogVisible} onClose={this.handleCloseDialog} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title"><Trans>{t('QualityDocPath')}</Trans></DialogTitle>
                    <DialogContent>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <a href={this.state.DialogContent}>{this.state.DialogContent}</a>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary" onClick={this.handleCloseDialog}>
                            <Trans>{t('Close')}</Trans>
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid container spacing={0}>
                    <Grid item xs={1}>
                        
                    </Grid>
                    <Grid item xs={10}>
                        {ordersteps.length ? ordersteps : <Paper className="orderInfoPaper"><Trans>{t('DataLoading')}</Trans></Paper>}
                    </Grid>
                    <Grid item xs={1}>
                        <Fab color="primary" aria-owns={anchorEl ? 'simple-menu' : undefined}
                            aria-haspopup="true"
                            onClick={this.handleClick}
                            className="ActionButton">
                            <ListIcon></ListIcon>
                        </Fab>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'center',
                            }}
                            transformOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            open={Boolean(anchorEl)}
                            onClose={this.handleClose}>
                            <MenuItem onClick={() => this.sendToQdoc()}><Trans>{t('Send to QDOC')}</Trans></MenuItem>
                            <MenuItem>
                                <Link className="navLinkAsButton" to={`/cncInfoIndex/${this.props.match.params.ordernumber}/${encodeURIComponent(this.props.match.params.productionOrderID)}`}>
                                    <Trans>{t('Overview CNC program')}</Trans>
                                </Link> 
                            </MenuItem>
                            <MenuItem onClick={() => this.showQualityDocument()}><Trans>{t('Quality documents')}</Trans></MenuItem>
                        </Menu>
                    </Grid>
                </Grid>
            
            </div>
        )
    }
}

export default OrderInfoPage;